query Me {
  me {
    id
    name
    roles
  }
}
